import { createUseStyles } from "react-jss";

export const InvoiceBulkResubmitStyles = createUseStyles({
    resubmit: {
        paddingRight: "10px"
    },
});
